<template>
  <div class="app-navbar-actions space-x-2 pr-2">
    <ThemeDropdown class="app-navbar-actions__item mr-3" />
    <LanguageDropdown class="app-navbar-actions__item app-navbar-actions__item--profile mr-3" />
    <span class="mr-3">{{ userName }}</span>
    <VaIcon name="vuestic-iconset-auth" class="mr-3" @click="logout" />
  </div>
</template>

<script lang="ts" setup>
import { useAuthStore } from '../../../stores/auth-store'
import { useRouter } from 'vue-router'
import ThemeDropdown from './dropdowns/ThemeDropdown.vue'
import LanguageDropdown from './dropdowns/LanguageDropdown.vue'

const router = useRouter()

const authStore = useAuthStore()
//console.log('userdata:')
//console.log(authStore.userdata)
const logout = () => {
  authStore.authLogout()
  const startpage = '/auth/login'
  alert('Logged out')
  router.push(startpage)
}
const userName = authStore.userdata.user_login
defineProps({
  isMobile: { type: Boolean, default: false },
})

//import { useI18n } from 'vue-i18n'
//const { t } = useI18n()
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}
</style>
